<div class="orderButton" *ngIf="showOrderButton && !isGroupPack" [ngClass]="{'orderButtonPlay': isPlay && isPlayAndInfoPage}" >
  <span
    class="product-detail-order-link uppercase"
    [ngClass]="{'product-detail-order-link-active': activeClass, 'has-package-already': isSubscribedToPackOrSubPack}"
    [translate]="buttonTextKey" [translateParams]="{packageName: packName()}">
  </span>
  <p class="info" *ngIf="isPlayMoreAndUpgradeFromTrial" [translate]="'eos-tv-shop-ii.btn.order-immediate-upgrade'"></p>
</div>
<div class="orderButton" *ngIf="showPendingOrderInfo">
  <div class="product-detail-order-link is-order-not-possible">
    <div class="order-data">
      <div class="order-not-possible" [translate]="'eos-tv-shop-ii.text.order-temporarily-not-possible-order-processing'"></div>
    </div>
  </div>
</div>
<div class="orderButton" *ngIf="showDowngradeMessage">
  <div *ngIf="pack?.collectionBlock" class="product-detail-order-link is-downgrade">
    <div class="order-data">
      <div class="order-not-possible" [translate]="'eos-tv-shop-ii.text.order-temporarily-not-possible'"></div>
      <div class="contact-info" [translate]="'eos-tv-shop-ii.text.please-contact-the-following-number'"></div>
    </div>
  </div>
  <div class="info-pack-downgrade" *ngIf="!pack?.collectionBlock || showDowngradeMessage" [translate]="'eos-tv-shop-ii.btn.order-downgrade'" [translateParams]="{packageName: packName(), upgradePack: superiorSubscribedPackName()}"></div>
</div>
